import React, { FC } from "react";
import { Logo } from "@telia/teddy";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../models";
import { getAppearance } from "../../../../app/state/selectors";

const NexusLogoSymbol: FC = () => {
    const appearance = useSelector((state: RootState) => getAppearance(state));

    return (
        <Logo
            orientation="symbol"
            variant={appearance === "dark" ? "secondary" : "default"}
            alt="Telia Norge"
            width={31}
            height={31}
        />
    );
};

export default NexusLogoSymbol;
